export default function (): typeof window.I18n {
  return window.I18n
}
